import { Link } from 'react-router-dom';
import { stats } from '@/mocks/comics';

export default function StatsSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-stone-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="lg:w-[45%]">
            <p className="text-stone-500 text-sm leading-relaxed mb-8 max-w-md">
              韩漫屋创立于2023年，专注于为华语读者提供优质的韩国漫画在线阅读服务。我们与多家韩国漫画平台合作，拥有超过5000部正版授权漫画资源，涵盖恋爱、悬疑、奇幻、搞笑等多种类型。
            </p>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-green-50 text-green-700 rounded-full text-sm font-medium hover:bg-green-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多关于我们 <i className="ri-arrow-right-line"></i>
            </Link>

            <div className="mt-14 grid grid-cols-2 gap-8">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <p className="text-3xl md:text-4xl font-black text-stone-800 tracking-tight">{stat.value}</p>
                  <p className="mt-1 text-xs text-stone-400 uppercase tracking-wider">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[55%] relative">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Collage%20of%20Korean%20manhwa%20covers%20and%20reading%20interface%2C%20warm%20cream%20background%2C%20editorial%20layout%2C%20clean%20and%20modern%20design%2C%20various%20colorful%20comic%20covers%20arranged%20artistically%2C%20soft%20shadows%2C%20professional%20composition%2C%20elegant%20presentation&width=1200&height=900&seq=stats-collage&orientation=landscape"
                alt="韩漫屋平台展示"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute top-4 left-4">
                <span className="px-3 py-1.5 bg-white/95 backdrop-blur-sm rounded-full text-xs font-medium text-stone-700 whitespace-nowrap">
                  韩漫大全平台
                </span>
              </div>
            </div>

            <div className="mt-4 flex items-center justify-between text-sm text-stone-500 px-1">
              <span>每日更新 · 高清画质</span>
              <span>100万+ 漫迷选择</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}